import Crown from '../svg/crown'

export default function TopBidderRibbon({ ...rest }) {
  return (
    <div {...rest}>
      <Crown width={17} height={17} />
      <span>You are the top bidder</span>

      <style jsx>{`
        div {
          display: inline-block;
          padding: 0.8rem 1.3rem;
          border-radius: 1.8rem;
          background: #152a46;
          color: #fff;
          white-space: nowrap;
          font-weight: 700;
          font-size: 1.4rem;

          :global(svg) {
            margin: 0 1.2rem 0 0;
            vertical-align: middle;
          }

          span {
            vertical-align: middle;
          }
        }
      `}</style>
    </div>
  )
}
